const DisclaimerSection = () => {
  return (
    <div className="bg-muted/50 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <p className="text-sm text-muted-foreground text-center leading-relaxed">
          <strong>Aviso:</strong> As informações contidas neste portal foram extraídas de fontes oficiais e veículos de comunicação confiáveis,
          porém podem conter erros, imprecisões ou estar desatualizadas. Este conteúdo tem caráter exclusivamente informativo e não substitui
          a orientação de profissionais especializados. Em caso de dúvidas, consulte um advogado, contador, corretor de imóveis ou o órgão
          público responsável pela sua jurisdição.
        </p>
      </div>
    </div>
  );
};

export default DisclaimerSection;
